import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Select } from "~/components/Select/Select";
import { convertTagToSelectOption } from "~/components/TagsSelect/utils";
import { TAGS_SELECT } from "~/constants/testIDs";
export const TagsSelect = (param)=>{
    let { tags, onTagsSelectionChange, selectedTags = [], placeholder = "Search for tags", ...props } = param;
    const options = tags.map((tag)=>convertTagToSelectOption(tag));
    const onTagsChange = useCallback((param)=>{
        let { chips } = param;
        onTagsSelectionChange === null || onTagsSelectionChange === void 0 ? void 0 : onTagsSelectionChange(chips);
    }, [
        onTagsSelectionChange
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        "data-testid": TAGS_SELECT,
        options: options,
        onSelectionChange: onTagsChange,
        selectedOptions: selectedTags,
        className: "w-full",
        renderAsInput: true,
        isClearable: true,
        isSearchable: true,
        highlightFirstOptionOnSearch: true,
        highlightFirstOptionOnOpen: true,
        preventPressEnterToAddWhenSearching: true,
        placeholder: placeholder,
        ...props
    });
};
